module.exports = __webpack_public_path__ + "static/img/ban1.69f62c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ban1.jpg
// module id = WnqX
// module chunks = 1